module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("The "), _c('strong', [_vm._v("Digital SLR")]), _vm._v(" Expert")]), _vm._v(" "), _c('h1', {
    staticClass: "title1"
  }, [_vm._v("LANDSCAPES")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('em', [_vm._v("essential advice from top pros")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("TOM MACKIE • WILLIAM NEILL • DAVID NOTON • DARWIN WIGGETT • TONY WOROBIEC")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("Edited by Cathy Joseph")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/logo.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66f6f1bd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781446352496_epub_tp.vue
// module id = 57
// module chunks = 0